import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FileService } from 'src/app/core/services/file/file.service';
import { ImageItem } from '../images-manager/images-manager.component';

@Component({
	selector: 'app-images-selector',
	standalone: true,
	imports: [],
	templateUrl: './images-selector.component.html',
	styleUrl: './images-selector.component.scss',
})
export class ImagesSelectorComponent implements OnInit {
	@Input() locationId?: string;
	@Input() flightId?: string;
	@Output() selectionChanged = new EventEmitter<ImageItem[]>();

	images: ImageItem[] = [];
	selectedImages = new Set<string>();

	constructor(private fileService: FileService) {}

	ngOnInit() {
		this.loadImages();
	}

	async loadImages() {
		try {
			const result = await this.fileService.getImageFiles(this.locationId || this.flightId);
			const imagePromises = result.items.map(async (item: any, index: number) => {
				const fullPath = item._location.path_;
				const filename = fullPath.split('/').pop() || `image-${index}`;
				const downloadURL = await this.fileService.getDownloadURL(item);
				return {
					id: `${Date.now()}-${index}`,
					filename: filename,
					url: downloadURL,
					reference: fullPath,
					uploadDate: new Date(),
				} as ImageItem;
			});
			this.images = await Promise.all(imagePromises);
		} catch (error) {
			console.error('Error loading images:', error);
		}
	}

	toggleImageSelection(image: ImageItem) {
		if (this.selectedImages.has(image.id)) {
			this.selectedImages.delete(image.id);
		} else {
			this.selectedImages.add(image.id);
		}

		this.emitSelectedImages();
	}

	isImageSelected(image: ImageItem): boolean {
		return this.selectedImages.has(image.id);
	}

	private emitSelectedImages() {
		const selected = this.images.filter((img) => this.selectedImages.has(img.id));
		this.selectionChanged.emit(selected);
	}
}
